module.exports = __webpack_public_path__ + "img/brunch-background.844e02ab.jpg";